import { __assign, __extends, __rest } from "tslib";
import * as React from 'react';
import { Colors } from '../colors/color';
import ClearIcon from '../icon/Clear';
var CLEAR_COLOR_DEFAULT = Colors.WarmGray['250'].hex;
var CLEAR_COLOR_ERROR = Colors.Red.Toxic.hex;
var InputClear = (function (_super) {
    __extends(InputClear, _super);
    function InputClear() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputClear.prototype.render = function () {
        var _a = this.props, error = _a.error, other = __rest(_a, ["error"]);
        var fill = error ? CLEAR_COLOR_ERROR : CLEAR_COLOR_DEFAULT;
        return (React.createElement("span", __assign({}, other),
            React.createElement(ClearIcon, { fill: fill })));
    };
    return InputClear;
}(React.Component));
export default InputClear;
//# sourceMappingURL=InputClear.js.map